import type { ReactNode } from 'react';
import { Alert, Box, CircularProgress } from '@mui/material';
import { useAuth } from '@/providers/AuthProvider';

/**
 * Route guard for internal tools. Hiding an item from the sidebar only removes
 * the signpost — the URL still works — so admin-only pages are wrapped in this.
 */
export function AdminOnly({ children }: { children: ReactNode }) {
  const { role } = useAuth();

  if (role === null) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', p: 6 }}>
        <CircularProgress />
      </Box>
    );
  }
  if (role !== 'admin') {
    return <Alert severity="error">此頁面僅限管理員存取</Alert>;
  }
  return <>{children}</>;
}
